__turbopack_context__.v({
  "divider": "_0CBwZq_divider",
  "inverted": "_0CBwZq_inverted",
  "padded": "_0CBwZq_padded",
  "section__container": "_0CBwZq_section__container",
  "section__content": "_0CBwZq_section__content",
  "section__heading": "_0CBwZq_section__heading",
  "ypadded": "_0CBwZq_ypadded",
});
